// Angular import
import { HttpClient } from '@angular/common/http';
// 3rd Party imports
import { classToPlain, plainToClass } from 'class-transformer';
import { map } from 'rxjs/operators';
// Constant imports
import { URLConstants } from '../../../_constants/url-constants';
import { ManageVendorContractResultDto } from '../_models/manage-vendor-contract-result-dto';
import { VendorContractEditorResultDto } from '../_models/vendor-contract-editor-result-dto';
import { VendorInsuranceDocumentEditorResultDto } from '../_models/vendor-insurance-document-editor-result-dto';
import { VendorAccountNumberVerifyResultDto } from '../_models/vendor-account-number-verify-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class VendorManagementSharedService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getInsuranceDocumentEditor(params) {
        const url = `${URLConstants.ccCommunityVendorBaseApiUrl}/insurance/document/editor${params.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((responseData) => plainToClass(VendorInsuranceDocumentEditorResultDto, responseData)));
    }
    uploadInsuranceDocument(params) {
        const url = `${URLConstants.ccCommunityVendorBaseApiUrl}/insurance/document`;
        return this.httpClient.post(url, classToPlain(params));
    }
    getManageVendorContract(params) {
        const url = `${URLConstants.ccCommunityVendorBaseApiUrl}/contracts${params.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((responseData) => plainToClass(ManageVendorContractResultDto, responseData)));
    }
    getContractEditor(params) {
        const url = `${URLConstants.ccCommunityVendorBaseApiUrl}/contract/editor${params.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((responseData) => plainToClass(VendorContractEditorResultDto, responseData)));
    }
    updateContract(params) {
        const url = `${URLConstants.ccCommunityVendorBaseApiUrl}/contract`;
        return this.httpClient.put(url, classToPlain(params));
    }
    addContract(params) {
        const url = `${URLConstants.ccCommunityVendorBaseApiUrl}/contract`;
        return this.httpClient.post(url, classToPlain(params));
    }
    verifyVendorAccountNumber(params, contextUrl) {
        const url = contextUrl;
        return this.httpClient
            .post(url, classToPlain(params))
            .pipe(map((response) => plainToClass(VendorAccountNumberVerifyResultDto, response)));
    }
}
VendorManagementSharedService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VendorManagementSharedService_Factory() { return new VendorManagementSharedService(i0.ɵɵinject(i1.HttpClient)); }, token: VendorManagementSharedService, providedIn: "root" });
